const productContainer = document.querySelector('.product-content-container')

const config = { attributes: true, childList: true, subtree: true };
const callback = (mutationList, observer) => {
    const hiddenPrice = productContainer.querySelector('[id*="price-template"] .bss-lock-element');
    if (hiddenPrice) {
        const wholesaleRows = productContainer.querySelectorAll('.tdf_wholesale_level .tdf_money');
        wholesaleRows.forEach(rowPrice => {
            if (rowPrice.querySelector('.bss-lock-element')) return;
            const newHiddenPriceElement = hiddenPrice.cloneNode(1);
            console.log(newHiddenPriceElement)
            rowPrice.replaceChildren(newHiddenPriceElement);
        });
    }

};
const observer = new MutationObserver(callback);
if (productContainer) observer.observe(productContainer, config);
